export const VIEWPORT_WIDTHS = {
  small: 640,
  medium: 1024,
  large: 1280,
};
